import { NgClass } from '@angular/common';
import { Component, computed, inject, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { RoleApiService } from '@core/services/role-api.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MenuItem } from '../menu-item.interface';

@Component({
  selector: 'app-nav',
  standalone: true,
  imports: [RouterModule, FontAwesomeModule, NgClass],
  template: `
    <div class="border-b border-gray-200">
      <nav class="-mb-px flex space-x-8" aria-label="Tabs">
        @for (item of items; track item.path) {
          <a
            (click)="navigate(item.path)"
            [ngClass]="{ 'border-secondary text-secondary font-bold border-b-2': isActive(item.path) }"
            class="group inline-flex items-center px-1 py-3 text-sm text-gray-500 cursor-pointer hover:border-primary hover:border-b-2 hover:text-primary hover:font-bold transition duration-200 ease-in-out"
          >
            @if (item.icon) {
              <fa-icon class="mr-2 -ml-0.5 size-5 group-hover:text-primary" [icon]="item.icon"></fa-icon>
            }
            <span>{{ item.label }}</span>
          </a>
        }
      </nav>
    </div>
  `,
})
export class NavComponent implements OnInit {
  @Input() items: MenuItem[] = [];

  private roleService = inject(RoleApiService);
  private authService = inject(AuthService);
  private role = this.authService.currentUser()?.roleId;
  private router = inject(Router);

  activeRoute = '';

  ngOnInit() {
    console.log('NavComponent - Items recibidos:', this.items);
  }

  constructor() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.activeRoute = event.urlAfterRedirects;
      }
    });
  }

  navigate(path: string) {
    console.log('Navegando a:', path);
    this.router.navigate([`/dashboard/${path}`]);
  }

  isActive(route: string): boolean {
    return this.activeRoute.includes(route);
  }
}
